import { Observable } from "rxjs";
import { ITokenPair } from "../features/auth/interface/dto/token-pair";
import { TrackedListColumns } from "../pages/tracked-lists/enum/tracked-list-columns";
import { ITrackedListDto } from "../pages/tracked-lists/interface/dto/tracked-lists.dto";
import { post } from "./api";

interface IFetchListsPayload {
    limit: number;
    offset: number;
    sortField?: TrackedListColumns;
    sortDirection?: "asc" | "desc";
    query?: string;
}

export const getTrackedList = (
    params: IFetchListsPayload,
    tokens: ITokenPair,
): Observable<ITrackedListDto> =>
    post<ITrackedListDto, IFetchListsPayload>(
        "/lists/tracked/search",
        params,
        undefined,
        tokens,
    );
